import cls from 'classnames';
import qsa from 'dom-helpers/querySelectorAll';
import React, { Component, createRef, RefObject } from 'react';
import { AppState } from 'core/redux/reducers';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { selectTranslator } from 'core/redux/features/languages/trans';
import { selectBookingStepData } from 'core/redux/features/booking/reducers';
import { BookingStep2 } from 'core/redux/features/booking/types';
import { actions } from 'core/redux/features/booking';
import { actions as sharedActions } from 'core/redux/features/shared';
import { connect, shallowEqual } from 'react-redux';
import FormStepContainer from '../Components/FormStepContainer';
import { Column, Columns } from 'Components/Elements/Layouts';
import FormField from '../Components/FormField';
import Summary from '../Components/Summary';
import FieldPhoneInput from '../Components/FieldPhoneInput';
import { ValuesType } from 'utility-types';
import BookingNextLoading from '../Components/BookingNextLoading';
import Box from 'Components/Box';

const mapStateToProps = (state: AppState) => ({
  product: selectActiveProduct(state),
  productMenus: state.products.entities.menus,
  trans: selectTranslator(state),
  loading: state.booking.loading,
  timeList: state.booking.times,
  step: selectBookingStepData(state, 1) as BookingStep2,
  orders: state.booking.order,
});

const mapDispatchToProps = {
  onChangeNumPerson: actions.selectNumberOfPerson,
  onChangeCartTime: actions.selectTime,
  onFillField: actions.fillForm,
  onValidateGiftcode: actions.giftcodeValidateRequest,
  onGiftcardRemove: actions.giftcardRemoveRequest,
  confirm: sharedActions.notifyConfirm,
  onValidateCoopCode: actions.coopCodeValidateRequest,
};

interface IOwnProps {}

type TProps = IOwnProps &
  typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps>;
type TStateInputs = {
  name: string;
  email: string;
  phone: string;
  is_subscribe: boolean;
  last_giftcode: string;
  coop_code: number | null | undefined;
  coop_zip: number | null | undefined;
};
type TState = TStateInputs & {
  country: string;
  showCoop: boolean;
};

let focusTimout: any = undefined;
let isDoneFocus = true;

class Step2Comp extends Component<TProps, TState> {
  state = {
    country: 'DK',
    name: this.props.step.data.name,
    email: this.props.step.data.email,
    phone: this.props.step.data.phone,
    is_subscribe: this.props.step.data.is_subscribe,
    last_giftcode: this.props.step.data.last_giftcode,
    coop_code: this.props.step.data.coop_code,
    coop_zip: this.props.step.data.coop_zip,
    showCoop: false,
  };

  gcInputRef: RefObject<HTMLInputElement> = createRef();
  coopInputRef: RefObject<HTMLInputElement> = createRef();

  componentDidUpdate(
    prevProps: Readonly<TProps>,
    prevState: Readonly<TState>,
    snapshot?: any,
  ): void {
    // empty last giftcode field & state when it's successfully applied
    const { step } = this.props;
    if (
      this.gcInputRef &&
      step.data.giftcodes !== prevProps.step.data.giftcodes &&
      step.data.giftcodes.findIndex(c => c === this.state.last_giftcode) > -1
    ) {
      this.setState({
        last_giftcode: '',
      });

      this.gcInputRef.current.value = '';
    }

    const errors = Object.entries(step.errors);

    if (
      errors.length > 0 &&
      !shallowEqual(prevProps.step.errors, step.errors)
    ) {
      const [firstErrField] = errors[0];
      if (firstErrField) {
        const $findEl = qsa(
          document,
          `#book-step2 input[name="${firstErrField}"]`,
        );

        let foundEl = $findEl.length > 0 ? $findEl[0] : undefined;

        if (foundEl) {
          clearTimeout(focusTimout);
        }

        focusTimout = setTimeout(() => {
          if (foundEl) {
            // isDoneFocus = true;
            foundEl.focus();
          }
        }, 800);
      }
    }
  }

  /**
   * Handle all input onChange events
   */
  private handleInputChange = (
    field: keyof TStateInputs,
    value: ValuesType<TStateInputs>,
  ) => {
    if (!this.props.loading) {
      this.setState({
        ...this.state,
        [field]: value,
      });
    }
  };

  onChangeCountryCode = (country: string) => {
    this.setState({
      country,
    });
  };

  onUseGiftcode = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const { last_giftcode, email, phone } = this.state;
    // if (this.handleCoopKeyword(e)) {
    //   return;
    // }

    this.props.onValidateGiftcode(last_giftcode, email, phone);
  };

  onKeyDownGiftCode = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      this.onUseGiftcode(e);
    }
  };

  handleCoopKeyword(e: React.SyntheticEvent) {
    const { last_giftcode, showCoop } = this.state;

    let isCoop = last_giftcode.toLowerCase() === 'coop';

    if (!isCoop && showCoop) {
      this.setState({
        ...this.state,
        showCoop: false,
        coop_code: undefined,
        coop_zip: undefined,
      });
    }

    if (isCoop && !showCoop) {
      this.setState({
        ...this.state,
        showCoop: true,
        last_giftcode: '',
      });

      setTimeout(() => {
        this.coopInputRef.current.focus();
      }, 150);

      return true;
    }

    return false;
  }

  onUseCoopCode = (e: React.SyntheticEvent) => {
    e.preventDefault();
    // const { coop_code, coop_zip } = this.state;
    // this.props.onValidateCoopCode(coop_code, coop_zip);
  };

  onKeyDownCoopCode = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      this.onUseCoopCode(e);
    }
  };

  onRemoveGiftcode = (code: string) => {
    const { onGiftcardRemove, trans } = this.props;
    this.props.confirm(
      () => {
        return new Promise<void>(r => {
          onGiftcardRemove(code);
          r();
        });
      },
      '',
      // trans('remove_gcode_title'),
      trans('remove_gcode_confirm'),
    );
  };

  onGetFormInputs = () => {
    return this.state;
  };

  render() {
    const { product, step, loading, trans, orders } = this.props;
    if (!product) {
      return null;
    }

    let showCoopZip =
      step.data.coop_code && String(step.data.coop_code).length >= 1;

    return (
      <FormStepContainer
        id="book-step2"
        onGetFormInputs={this.onGetFormInputs}
        enableNextBtn={true}
      >
        <Column
          className="checkout__content__items checkout--right-border"
          size={['8-tablet']}
        >
          <BookingNextLoading hide={!loading} />
          <div className="step-fields">
            <FormField
              label={trans('fullname')}
              field="name"
              errors={step.errors}
            >
              <input
                onChange={e => this.handleInputChange('name', e.target.value)}
                defaultValue={this.state.name}
                name="name"
                className="input"
                type="text"
                placeholder=""
              />
            </FormField>
            <FormField
              label={trans('emailfield')}
              field="email"
              errors={step.errors}
            >
              <input
                onChange={e => this.handleInputChange('email', e.target.value)}
                defaultValue={this.state.email}
                name="email"
                className="input"
                type="text"
                placeholder=""
              />
            </FormField>
            <FormField
              label={trans('phonenum')}
              field="phone"
              errors={step.errors}
            >
              <FieldPhoneInput
                country={this.state.country}
                value=""
                name="phone"
                onChangeCountry={this.onChangeCountryCode}
                onChange={value => this.handleInputChange('phone', value)}
              />
            </FormField>
            <div className="spacer" />
            <FormField
              onClick={e =>
                this.handleInputChange('is_subscribe', !this.state.is_subscribe)
              }
            >
              <input
                onChange={_ => {}}
                name="is_subscribe"
                className="is-checkradio has-background-color is-danger is-large"
                type="checkbox"
                checked={this.state.is_subscribe}
              />
              <label htmlFor="is_subscribe" className="subscribe-ck">
                <span className="is-size-6">
                  <Box code="checkout_news_ck" />
                </span>
              </label>
            </FormField>
            <div className="spacer" />
            <FormField
              label={trans('giftcode')}
              field="last_giftcode"
              errors={step.errors}
            >
              <FormField hasAddon={true}>
                <p className="control is-full">
                  <input
                    defaultValue={this.state.last_giftcode}
                    onChange={e =>
                      this.handleInputChange('last_giftcode', e.target.value)
                    }
                    onKeyPress={this.onKeyDownGiftCode}
                    ref={this.gcInputRef}
                    className="input"
                    data-key-handled={1}
                    type="text"
                  />
                </p>
                <p className="control">
                  <button
                    className="button is-danger"
                    onClick={this.onUseGiftcode}
                    disabled={loading || this.state.last_giftcode.length === 0}
                  >
                    {trans('use')}
                  </button>
                </p>
              </FormField>
            </FormField>

            <FormField control={false} controlClass="tags">
              {step.data.giftcodes.map(code => {
                return (
                  <div key={code} className="control is-giftcode-tag">
                    <div className="tags has-addons">
                      <span className="tag">{code}</span>
                      <a
                        onClick={_ => this.onRemoveGiftcode(code)}
                        className="tag is-delete"
                      />
                    </div>
                  </div>
                );
              })}
            </FormField>

            <Columns
              mobile={true}
              style={{
                display: this.state.showCoop ? '' : 'none',
              }}
            >
              <Column
                size={
                  String(this.props.step.data.coop_code).length !== 8 ? [] : [6]
                }
              >
                <FormField
                  label={trans('coop_mem_no')}
                  field="coop_code"
                  errors={step.errors}
                  successMsg={
                    orders.cards &&
                    orders.cards.find(item => item.card_type === 'coop') &&
                    trans('coop_member_registered')
                  }
                >
                  <FormField hasAddon={!showCoopZip}>
                    <p className="control is-full">
                      <input
                        defaultValue={this.state.coop_code}
                        onChange={e =>
                          this.handleInputChange('coop_code', e.target.value)
                        }
                        onKeyPress={this.onKeyDownCoopCode}
                        className="input"
                        type="number"
                        ref={this.coopInputRef}
                        data-key-handled={1}
                      />
                    </p>
                    <p className={cls('control', showCoopZip && 'hide')}>
                      <button
                        className={cls('button is-danger')}
                        onClick={this.onUseCoopCode}
                        disabled={loading || !this.state.coop_code}
                      >
                        {trans('use')}
                      </button>
                    </p>
                  </FormField>
                </FormField>
              </Column>
              <Column className={cls(!showCoopZip && 'hide')}>
                <FormField
                  label={trans('zip_code')}
                  field="coop_zip"
                  errors={step.errors}
                >
                  <FormField hasAddon={true}>
                    <p className="control is-full">
                      <input
                        defaultValue={this.state.coop_zip}
                        onChange={e =>
                          this.handleInputChange('coop_zip', e.target.value)
                        }
                        onKeyPress={this.onKeyDownCoopCode}
                        className="input"
                        type="number"
                        data-key-handled={1}
                      />
                    </p>
                    <p className="control">
                      <button
                        className="button is-danger"
                        onClick={this.onUseCoopCode}
                        disabled={false}
                      >
                        {trans('use')}
                      </button>
                    </p>
                  </FormField>
                </FormField>
              </Column>
            </Columns>

            <div className="spacer-s" />
            <div className="spacer-s" />
          </div>
        </Column>
        <Column
          className="checkout__content__summary checkout__content__items checkout--bg-blue"
          size={'4'}
        >
          <Summary />
        </Column>
      </FormStepContainer>
    );
  }
}

// const StepsRoot =
//   process.env.NODE_ENV !== 'production' ? hot(Step2Comp) : Step2Comp;
const Step2 = connect(mapStateToProps, mapDispatchToProps)(Step2Comp);
export default Step2;
